module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Regular.350c486.woff";